// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HaNIi","col":"styles_col__2zYGp","actions":"styles_actions__2SPTm","conflict":"styles_conflict__2kPqy"};